import React, { useEffect, useState } from 'react';
import { Box } from '@common-fe/common-fe';

import ModuleTitle from '@/components/elements/ModuleTitle/ModuleTitle';

import LogList from './LogList';

interface Props {
  title?: string;
  collapseSignal?: number;
  expandSignal?: number;
}

const ActivityLog: React.FC<Props> = ({ title, collapseSignal, expandSignal }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (collapseSignal) {
      setIsExpanded(false);
    }
  }, [collapseSignal]);

  useEffect(() => {
    if (expandSignal) {
      setIsExpanded(true);
    }
  }, [expandSignal]);

  if (title) {
    return (
      <>
        <ModuleTitle
          testId="ActivityLog"
          title={title}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
        />
        {isExpanded ? (
          <Box pad="spacing24" background="module" round="small" margin={{ top: 'spacing16' }}>
            <LogList />
          </Box>
        ) : null}
      </>
    );
  }

  return <LogList />;
};

export default ActivityLog;
